module.exports = __webpack_public_path__ + "img/header-diamondJewelry@2x.5b7e141.webp";